module.exports = __webpack_public_path__ + "fonts/panda.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/svgs/panda.svg
// module id = 602
// module chunks = 5